import { toEDNStringFromSimpleObject } from "edn-data";
import { queryOmegaSingleResult } from "../../api";
import { Component } from "../../types/component";
import { PageComponent } from "../../types/page/component";

export const getPageComponent: (config: {
  "app-id": string;
  "page-id": string;
}) => Promise<PageComponent> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config, { keysAs: "string" });
  const query = `
        (datastore Qo.Public.Api.Page.Comp "omega/query-omega/public/api/page/component")
        (Qo.Public.Api.Page.Comp/get-page-component ${ednString} Response)
        (return [Response])
    `;
  const response = await queryOmegaSingleResult(query);
  return response;
};
